<template>
  <div>
    <!-- Current version at the top -->
    <div v-if="version === 'v2'">
      <!-- Not handling @click event as it bubbles up -->
      <button
        :disabled="disabled"
        :class="colorClass"
        class="px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-md sm:px-8"
        ><slot>Click me</slot>
      </button>
    </div>
    <div v-else-if="version === 'v1'">
      <div :class="colorClass"
      class="px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-md sm:px-8 cursor-pointer"
      ><slot></slot></div>
    </div>
    <div v-else>
      INVALID VERSION {{ version }}. Check your code!!!
    </div>
  </div>
</template>
<script setup>
defineProps({
  version: { type: String, default: "v1", },
  colorClass: {
      type: String,
      default: 'text-indigo-700 bg-slate-50 hover:bg-indigo-50'
  },
  disabled: { type: Boolean, default: false, },
});
</script>
